const today = new Date();
const dateTo = today.toISOString().split('T')[0];

const thirtyDaysAgo = new Date();
thirtyDaysAgo.setDate(today.getDate() - 30);
const dateFrom = thirtyDaysAgo.toISOString().split('T')[0];

export const getDateType = () => {

return {
    From: dateFrom ,
    To: dateTo
}

}